import { Typography } from '../../../atoms/typography/typography';
import { formatCurrency } from '@maia/utils';
import { useMemo } from 'react';

type PriceProps = {
  price: number;
};

export function Price(props: PriceProps) {
  const { price } = props;
  const formattedPrice = useMemo(() => formatCurrency(price), [price]);
  return (
    <Typography variant="body-xs" weight="regular">
      {formattedPrice}
    </Typography>
  );
}
